module.exports = __webpack_public_path__ + "img/icon_muscle.f80d5c39.svg";